// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { headerSignInStyles } from "@guestsupply/Overrides/Widgets/Common/HeaderSignIn";
import { color } from "@guestsupply/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

headerSignInStyles.tippyPopup = {
    main: {
        css: css`
            &&&.tippy-box {
                padding: 0;
            }
        `,
    },
};

headerSignInStyles.headerClickable = {
    title: {
        css: css`
            &:hover {
                color: ${color("text.main")};
            }
        `,
    },
    clickable: {
        css: css`
            ${IconWrapper} {
                color: ${color("text.main")};
                circle {
                    display: none;
                }
            }
            &:hover,
            &.opened {
                ${TypographyStyle} {
                    color: ${color("text.main")};
                }
                ${IconWrapper} {
                    color: ${color("common.ui9")};
                    path,
                    circle {
                        fill: ${color("common.ui9")};
                        display: block;
                    }
                }
            }
        `,
    },
};
